import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import './TrailFormSection.css';

interface TrailFormSectionProps {
  title: string;
  icon?: string;
  children: React.ReactNode;
  className?: string;
}

const TrailFormSection: React.FC<TrailFormSectionProps> = ({ 
  title, 
  icon, 
  children, 
  className = "" 
}) => {
  return (
    <Card className={`trail-form-section ${className}`}>
      <Card.Header className="trail-form-section-header">
        <Row className="align-items-center">
          <Col>
            <h5 className="mb-0">
              {icon && <i className={`${icon} me-2`}></i>}
              {title}
            </h5>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="trail-form-section-body">
        {children}
      </Card.Body>
    </Card>
  );
};

export default TrailFormSection;